// extracted by mini-css-extract-plugin
export default {"summary":"SummaryTable_summary__JyHyK","center":"SummaryTable_center__YDIF-"};